export const getStatusDisplayLabel = (status: string) => {
  switch(status) {
    case "open": 
    case "actie_luijten": 
      return "Actie Luijten";
    case "in_behandeling": 
    case "actie_decoprof": 
      return "Actie Decoprof";
    case "actie_winkel_ridderkerk":
      return "Actie winkel Ridderkerk";
    case "opgelost": 
    case "afgerond": 
      return "Afgerond";
    case "afwachting_klant":
      return "In afwachting van klant";
    case "afwachting_voorraad":
      return "In afwachting van nieuwe voorraad";
    case "afwachting_voorraad_ridderkerk":
      return "In afwachting van nieuwe voorraad winkel Ridderkerk";
    case "afwijkende_verzenddatum":
      return "Afwijkende verzenddatum";
    default:
      return status;
  }
};